import { render, staticRenderFns } from "./ControlAlteka.vue?vue&type=template&id=75db8bc7&scoped=true&"
import script from "./ControlAlteka.vue?vue&type=script&lang=js&"
export * from "./ControlAlteka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75db8bc7",
  null
  
)

export default component.exports